import React from "react";

export const CommercialIcon = ({ color = "#1D2540", ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.75 3C2.55109 3.00002 2.36034 3.07904 2.21969 3.21969C2.07904 3.36034 2.00002 3.55109 2 3.75V20.25C2.00002 20.4489 2.07904 20.6397 2.21969 20.7803C2.36034 20.921 2.55109 21 2.75 21H15.25C15.2814 20.9994 15.3127 20.9967 15.3438 20.9922C15.3767 20.997 15.41 20.9996 15.4434 21H21.25C21.4489 21 21.6397 20.921 21.7803 20.7803C21.921 20.6397 22 20.4489 22 20.25V7.75C22 7.55109 21.921 7.36034 21.7803 7.21969C21.6397 7.07904 21.4489 7.00002 21.25 7H16V3.75C16 3.55109 15.921 3.36034 15.7803 3.21969C15.6397 3.07904 15.4489 3.00002 15.25 3H2.75ZM3.5 4.5H14.5V19.5H3.5V4.5ZM6 7V9H8V7H6ZM10 7V9H12V7H10ZM16 8.5H20.5V19.5H16V17H18V15H16V13H18V11H16V8.5ZM6 11V13H8V11H6ZM10 11V13H12V11H10ZM6 15V17H8V15H6ZM10 15V17H12V15H10Z"
      fill={color}
    />
  </svg>
);

export const ResidentialIcon = ({ color = "#1D2540", ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.75 3C2.55109 3.00002 2.36034 3.07904 2.21969 3.21969C2.07904 3.36034 2.00002 3.55109 2 3.75V10.25C2.00002 10.4489 2.07904 10.6397 2.21969 10.7803C2.36034 10.921 2.55109 11 2.75 11H3V20.25C3.00002 20.4489 3.07904 20.6397 3.21969 20.7803C3.36034 20.921 3.55109 21 3.75 21H20.25C20.4489 21 20.6397 20.921 20.7803 20.7803C20.921 20.6397 21 20.4489 21 20.25V11H21.25C21.4489 11 21.6397 10.921 21.7803 10.7803C21.921 10.6397 22 10.4489 22 10.25V3.75C22 3.55109 21.921 3.36034 21.7803 3.21969C21.6397 3.07904 21.4489 3.00002 21.25 3H2.75ZM3.5 4.5H20.5V9.5H15.3066L12.4805 6.71484C12.3385 6.57553 12.1471 6.4983 11.9482 6.50013C11.7493 6.50196 11.5593 6.58271 11.4199 6.72461L8.68555 9.5H3.5V4.5ZM11.9609 8.31055L14.4746 10.7852C14.6148 10.9228 14.8035 11 15 11H19.5V19.5H11V14C11 13.448 10.552 13 10 13H8C7.448 13 7 13.448 7 14V19.5H4.5V11H9C9.09965 11 9.1983 10.9801 9.29018 10.9416C9.38207 10.903 9.46535 10.8465 9.53516 10.7754L11.9609 8.31055ZM14 13C13.448 13 13 13.448 13 14V16C13 16.552 13.448 17 14 17H16C16.552 17 17 16.552 17 16V14C17 13.448 16.552 13 16 13H14Z"
      fill={color}
    />
  </svg>
);
